import React from "react";
import { Download } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { dataTrigger } from "@/analytics";
import { Button } from "@/ui/Button/Button";

type Props = {
  configUrl: string;
};

export function VpnImportActions({ configUrl }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Button
      variant="primary"
      size="md"
      leftIcon={<Download />}
      {...dataTrigger("bkn.main.install")}
      onClick={() => {
        const currentParams = new URLSearchParams(location.search);
        const params = new URLSearchParams({ url: configUrl });
        const telegramId = currentParams.get("telegram_id");

        if (telegramId) {
          params.set("telegram_id", telegramId);
        }

        navigate({
          pathname: "/install-v2raytun",
          search: `?${params.toString()}`,
          hash: location.hash,
        });
      }}
    >
      Установить
    </Button>
  );
}
